(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsListEventsController', CmsListEventsController);

  /* ngInject */
  function CmsListEventsController($state, $stateParams, cmsEventService, sessionService) {

    const vm = this;

    vm.currentPage = $stateParams.currentPage || 1;
    vm.direction = $stateParams.direction || 'desc';
    vm.events = [];
    vm.getEvents = getEvents;
    vm.loading = false;
    vm.orderBy = orderBy;
    vm.order = $stateParams.order || 'start_at';
    vm.pageChange = pageChange;
    vm.query = $stateParams.query || null;
    vm.reload = reload;
    vm.totalCount = 9999;

    vm.getEvents();

    function getEvents() {
      vm.loading = true;
      let params = {
        page: vm.currentPage,
        sort: vm.order,
        direction: vm.direction,
        query: vm.query
      };

      cmsEventService(sessionService.getAuthToken()).query(params, response => {
        vm.events = response.events;
        vm.totalCount = response.meta.total_count;
        vm.loading = false;
      }, _ => {
        vm.loading = false;
      });
    }

    function pageChange(newPageNumber, oldPageNumber) {
      vm.currentPage = newPageNumber;

      if (newPageNumber != oldPageNumber) {
        reload();
      }
    }

    function orderBy(field) {
      if (vm.order.includes(field)) {
        if (vm.direction == 'desc') {
          vm.direction = 'asc';
        } else {
          vm.direction = 'desc';
        }
      } else {
        vm.direction = 'desc';
      }

      vm.order = field;

      reload();
    }

    function reload() {
      $state.go(
        'application.compliance_services.cms_list_events',
        { currentPage: vm.currentPage, order: vm.order, direction: vm.direction, query: vm.query },
        { reload: true, inherit: false, notify: true }
      );
    }
  }
})();
